<template>
  <div>
    <v-chip
      :color="chipColor"
      label
      small
    >
      <div class="d-flex">
        <span
          :class="textColor"
          class="texte align-self-center pr-1"
        >
          {{ etatUtilisation.libelle | capitalize }}
        </span>
      </div>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'StatutUtilisationChip',
  props: {
    etatUtilisation : {
      type: Object,
      required: true
    }
  },

  computed: {
    textColor () {
      switch(this.etatUtilisation.code) {
        case 'A_UTILISER':
        case 'EN_COURS_UTILISATION':
          return 'texte-orange-fonce'
        case 'FINALISE':
          return 'secondary--text'
        default:
          return '--text-white'
      }
    },

    chipColor () {
      switch(this.etatUtilisation.code) {
        case 'A_UTILISER':
        case 'EN_COURS_UTILISATION':
          return '#F6C9B1'
        case 'FINALISE':
          return 'var(--kaki)'
        default:
          return 'grey'
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
